export default function contatoNewsletter(){
    const contatoFormSubmit = document.querySelector('#form-newsletter-submit')
  contatoFormSubmit && contatoFormSubmit.addEventListener('submit', function(event) {
      event.preventDefault();
      disabledBtn()
      const form_data = {
        email: document.querySelector('#form-newsletter-submit #email').value,
      }
      const url = "/newsletter/"
      axios.post(url, form_data)
        .then((response) => showMessage(response))
        .catch((response) => showMessage(response));
    });

    function showMessage(response) {
      const message = response.data ? response.data.message : response.message
      GLOBAL.showToastify(message)
      contatoFormSubmit.reset()
      setTimeout(enabledBtn, 1000)
    }

    const btnSubmit = document.querySelector("#form-newsletter-submit .btn")

    function disabledBtn() {
      btnSubmit.disabled = true
      btnSubmit.style.opacity = ".5"
    }

    function enabledBtn() {
      btnSubmit.disabled = false
      btnSubmit.style.opacity = "1"
    }
}